import { NodeModel, TreeOptions, TreeSource, NodeSource } from "@omegagrid/tree";
import rp, { BrowserAdapter } from "@reporting/rp-app-host";
import { Project } from "@reporting/rp-types/ext";

export class AppBrowserAdapter extends BrowserAdapter {

	async getTree(): Promise<TreeSource> {
		const apps = await rp.ms('extensions').get<Project[]>(`customApplications`);
		return apps.map<NodeSource>(app => ({
			k: `extensions-view-${app.id_custom_resource}`,
			v: app.name,
			icon: 'shapes'
		}));
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
			search: false,
		};
	}

	async onAction(key: string, node: NodeModel) {}
}
